import { prop } from 'ramda';

export const countriesSelector = prop('countries');


// WEBPACK FOOTER //
// ./src/selectors/countriesSelectors.js